export default {
    // server: 'http://localhost:50003'
    server: 'https://zalazardistribuidora.com.ar'
};